import { __assign, __awaiter, __generator } from "tslib";
// @ts-ignore
import { DUMMY_BASE_URL, setSearchParams } from '@redhat-cloud-services/javascript-clients-shared/dist/common';
var isServicesGetObjectParams = function (params) {
    var l = params.length === 1;
    if (l && typeof params[0] === 'object' && !Array.isArray(params[0])) {
        return true;
    }
    return false;
};
/**
*
* @summary get a list of services a user is entitled to
* @param {ServicesGetParams} config with all available params.
* @param {*} [options] Override http request option.
* @throws {RequiredError}
*/
export var servicesGetParamCreator = function (sendRequest) {
    var config = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        config[_i - 1] = arguments[_i];
    }
    return __awaiter(void 0, void 0, void 0, function () {
        var params, _a, options, localVarPath, localVarUrlObj, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, args;
        return __generator(this, function (_b) {
            params = isServicesGetObjectParams(config) ? config[0] : ['options'].reduce(function (acc, curr, index) {
                var _a;
                return (__assign(__assign({}, acc), (_a = {}, _a[curr] = config[index], _a)));
            }, {});
            _a = params.options, options = _a === void 0 ? {} : _a;
            localVarPath = "/services";
            localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            localVarRequestOptions = __assign({ method: 'GET' }, options);
            localVarHeaderParameter = {};
            localVarQueryParameter = {};
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            localVarRequestOptions.headers = __assign(__assign({}, localVarHeaderParameter), options.headers);
            args = {
                urlObj: localVarUrlObj,
                options: localVarRequestOptions,
            };
            return [2 /*return*/, sendRequest(Promise.resolve(args))];
        });
    });
};
export default servicesGetParamCreator;
//# sourceMappingURL=index.js.map